<template>
	<svg
		width="203px"
		height="123px"
		viewBox="0 0 203 123"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		:class="{ animate }"
	>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g transform="translate(0.000000, -0.000000)">
				<g>
					<path
						d="M178.434949,123 C192.001091,123 203,111.98535 203,98.4 C203,84.81465 192.001091,73.8 178.434949,73.8 C177.985889,73.8 178.834798,73.7754 178.393939,73.8 C180.907859,67.57825 181.020636,60.85425 181.020636,53.73255 C181.020636,24.0547 156.996919,-7.10542736e-15 127.36097,-7.10542736e-15 C106.841566,-7.10542736e-15 89.0206263,11.5374 79.9922525,28.48475 C76.4407778,25.27445 71.7512727,23.3044 66.5901515,23.3044 C55.5215253,23.3044 46.5485152,32.28955 46.5485152,43.3739 C46.5485152,43.8167 46.5854242,44.2513 46.6141313,44.6859 C44.2847576,44.25745 41.8897677,44.0217 39.4373636,44.0217 C17.656899,44.0217 0,61.7009 0,83.51085 C0,105.3208 17.656899,123 39.4373636,123 L178.434949,123 Z"
						fill="#10C7AA"
					></path>
					<g transform="translate(71.000000, 48.000000)" fill="#FFFFFF">
						<path
							d="M30.9166667,0 C47.9915544,0 61.8333333,10.484473 61.8333333,23.4192044 C61.8333333,36.3539357 47.9915544,46.8384088 30.9166667,46.8384088 C28.0545538,46.8384088 25.2872061,46.5376953 22.6569657,45.9868934 L16.8067222,52.4790654 C15.8439473,53.5472565 14.0756677,52.8628042 14.0756677,51.4220118 L14.0756677,43.0556959 C5.60526516,38.8781068 -1.0658141e-14,31.6468073 -1.0658141e-14,23.4192044 C-1.0658141e-14,10.484473 13.8417789,0 30.9166667,0 Z M42.9473873,17.6666667 C39.6315032,17.6666667 36.9003578,20.1276785 36.4878992,23.3096741 L32.3004808,23.3096741 C31.9052501,21.1537714 30.0081428,19.5174603 27.7228987,19.5174603 C25.4386681,19.5174603 23.5415608,21.1537714 23.1453167,23.3096741 L18.8991204,23.3096741 C18.524158,21.8908665 17.2371248,20.8395996 15.6916714,20.8395996 C13.8553689,20.8395996 12.3666667,22.3188248 12.3666667,24.1444444 C12.3666667,25.9700641 13.8553689,27.4492893 15.6916714,27.4492893 C17.2371248,27.4492893 18.5251714,26.3970154 18.8991204,24.9782079 L23.1453167,24.9782079 C23.5415608,27.1351175 25.4386681,28.7714286 27.7228987,28.7714286 C30.0081428,28.7714286 31.9052501,27.1351175 32.3004808,24.9782079 L36.4878992,24.9782079 C36.9003578,28.1612104 39.6315032,30.6222222 42.9473873,30.6222222 C46.5480401,30.6222222 49.4666667,27.7221756 49.4666667,24.1444444 C49.4666667,20.5667133 46.5480401,17.6666667 42.9473873,17.6666667 Z"
						></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ProntoCloudIcon',
	props: { animate: { type: Boolean, default: null }},
}
</script>

<style lang="scss" scoped>
@keyframes float {
	0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-20px);
	}
	100% {
		transform: translatey(0px);
	}
}

svg {
	&.animate {
		animation: float 4s ease-in-out infinite;
	}
}
</style>
